// useThreadsQuery — load the recent chat-thread list.

import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { useThreadsApiClient } from '../api/useThreadsApiClient';
import { threadKeys } from './queryKeys';
import { toThreadSummaryList } from './toThreadView';
import type { ThreadSummaryView } from './types';

const DEFAULT_LIMIT = 50;

export function useThreadsQuery(
  limit: number = DEFAULT_LIMIT,
  enabled = true,
): UseQueryResult<ReadonlyArray<ThreadSummaryView>> {
  const client = useThreadsApiClient();
  return useQuery<ReadonlyArray<ThreadSummaryView>>({
    queryKey: threadKeys.list(limit),
    enabled,
    queryFn: async ({ signal }) => {
      const raw = await client.fetchList({ limit }, signal);
      return toThreadSummaryList(raw);
    },
  });
}
